import { IAppState } from '../../common/state';

export const selectQueryString = (state: IAppState): string => state.results.queryString;
